import { CustomSelect, FilterField, FilterPanel } from '../common';

function SalesOrderFilters({
  values,
  suggestions,
  statusOptions,
  onChange,
  onStatusChange,
  onSubmit,
  onReset,
}) {
  return (
    <FilterPanel
      onSubmit={onSubmit}
      onReset={onReset}
      layoutClassName="grid gap-2.5 md:grid-cols-2 xl:grid-cols-[minmax(0,1.2fr)_170px_190px_auto]"
    >
      <FilterField
        label="Search"
        name="search"
        type="search"
        value={values.search}
        onChange={onChange}
        placeholder="Search batch no. or customer"
        suggestions={suggestions}
      />
      <FilterField
        label="S.O. Date"
        name="soDate"
        type="date"
        value={values.soDate}
        onChange={onChange}
      />
      <CustomSelect
        label="Status"
        name="statusFilter"
        value={values.statusFilter}
        onChange={onStatusChange}
        options={[
          {
            value: 'ActivePartiallyReleasedCompletedUnpaid',
            label: 'Active + Partially Released + Completed (Unpaid)',
          },
          { value: 'All', label: 'All Status' },
          ...statusOptions,
        ]}
        searchable={false}
      />
    </FilterPanel>
  );
}

export default SalesOrderFilters;
